import { useState } from "react"
import { track } from 'services/redline'
import { cameraStatus } from "../components/TakePhotoButton/constants"

export const useUploadContext = () => {

	const uploadedFilesState = useState({})
	const docTypeState = useState('')
	const [ currentCameraStatus, setCurrentCameraStatus ] = useState(null)

	async function checkCameraPermission () {
		const cameraPermission = await navigator.permissions.query({ name: 'camera' })

		setCurrentCameraStatus(cameraPermission.state)

		if (cameraPermission.state !== cameraStatus.allowed) {
		  const userAgent = navigator?.userAgent

		  track('mediaStatusTracked', {
			userAgent,
			cameraPermission: 'permissionsQueryUndefined'
		  })
		}
	}

	return {
		uploadedFilesState,
		docTypeState,
		currentCameraStatusState: [ currentCameraStatus, setCurrentCameraStatus ],
		checkCameraPermission
	}
}
